module.exports = __webpack_public_path__ + "images/58a3fc36c97632004b0bc707ba47c56394e7162ffa6ad6fb4cce0802492de764.svg";